export const carModel = {
  brand: "",
  model: "",
  color: "",
  cost: "",
  engine_num: "",
  body_num: "",
  tech_passport: "",
  car_num: "",
  spare_wheel: "",
  battery: "",
  wheels_model: "",
  rent_cost: "",
  toning: "",
  year_of_issue: "",
};

export const carFilter = {
  brand: "",
  model: "",
  price: "",
  color: "",
};
